import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import Slider from '../slider/Index';
import NextButton from '../slider/NextButton';
import PrevButton from '../slider/PrevButton';
import ivclass from '../../Modules/IVClass';
const SliderTray = (props) => {
    const { platform, children, sliderWrapperCls = '' } = props;
    const SliderOptions = {};
    const showSlider = !(platform === 'mobile' ||
        platform === 'tablet' ||
        platform === 'smarttv');
    if (showSlider) {
        SliderOptions['renderButtons'] = (scrollPrev, scrollNext, prevBtnEnabled, nextBtnEnabled) => (_jsxs(Fragment, { children: [_jsx(PrevButton, { clickHandler: scrollPrev, isEndReached: prevBtnEnabled }), _jsx(NextButton, { clickHandler: scrollNext, isEndReached: nextBtnEnabled })] }));
    }
    else {
        SliderOptions['renderButtons'] = () => _jsx(_Fragment, {});
    }
    return ((showSlider && (_jsx(Slider, { sliderWrapperClasses: ivclass('iv-ml-20 lg:iv-ml-[0] md:iv-ml-[0] sm:iv-ml-[0] ', sliderWrapperCls), childrenWrapperClass: ivclass('iv-justify-start'), ...SliderOptions, children: children }))) || (_jsx("div", { className: ivclass('iv-overflow-x-auto', 'iv-flex', 'iv-no-scroll-bar-container'), children: children })));
};
export default SliderTray;
